import { render, staticRenderFns } from "./autoassess.vue?vue&type=template&id=63325c92&scoped=true"
import script from "./autoassess.vue?vue&type=script&lang=js"
export * from "./autoassess.vue?vue&type=script&lang=js"
import style0 from "./autoassess.vue?vue&type=style&index=0&id=63325c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63325c92",
  null
  
)

export default component.exports